module.exports = __webpack_public_path__ + "img/flecha.fcfb7030.png";